import React, { useState } from 'react';
import { Lock } from 'lucide-react';
import { useAdminSession } from '../../context/AdminSessionContext';
import { useAbortableTask } from '../../hooks/useAbortableTask';

function loginError(status, copy) {
  if (status === 401) return copy.incorrect;
  if (status === 429) return copy.throttled;
  return copy.failed;
}

export const AdminLogin = ({ copy }) => {
  const { login } = useAdminSession();
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [errorStatus, setErrorStatus] = useState(null);
  const task = useAbortableTask();
  const submit = async event => {
    event.preventDefault();
    if (!password.trim() || loading) return;
    const operation = task.start();
    setLoading(true); setErrorStatus(null);
    try { await login(password); }
    catch (error) { if (task.isCurrent(operation)) setErrorStatus(error.status || 500); }
    finally { if (task.isCurrent(operation)) setLoading(false); }
  };
  return <section className="bg-white py-16"><div className="mx-auto max-w-md px-6"><div className="rounded-2xl border border-slate-200 bg-white p-8 shadow-sm">
    <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-blue-50"><Lock className="h-6 w-6 text-blue-700" /></div>
    <h3 data-testid="admin-access-title" className="mt-5 text-xl font-bold text-slate-900">{copy.access}</h3><p className="mt-1.5 text-sm text-slate-500">{copy.prompt}</p>
    <form onSubmit={submit} className="mt-6 space-y-4" data-testid="admin-login-form">
      <input type="password" value={password} onChange={event => setPassword(event.target.value)} autoComplete="current-password" placeholder={copy.password} aria-label={copy.password} maxLength={512} required className="w-full rounded-lg border border-slate-200 bg-white px-4 py-3 text-slate-800" data-testid="admin-password-input" />
      {errorStatus && <p role="alert" className="error-message" data-testid="admin-login-error">{loginError(errorStatus, copy)}</p>}
      <button type="submit" disabled={loading || !password.trim()} className="w-full rounded-lg bg-blue-700 px-6 py-3 text-[15px] font-semibold disabled:opacity-60" data-testid="admin-login-button">{loading ? copy.signingIn : copy.unlock}</button>
    </form>
  </div></div></section>;
};